import { GetDocuments } from '@/connection/content/documents';
import { ContentReducerCreator } from '../types';

const loadDocumentsReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetDocuments(channel);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.documents = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadDocumentsReducer;
